import { useLocation as useRouterLocation } from 'react-router-dom';

type LocationType<T> = Location & {
  state: T;
};

export const useLocation = <T>() =>
  useRouterLocation() as unknown as LocationType<T>;
